<div class="flex-layout">
  <div class="flex-layout__custom">
    <app-branding *ngIf="!isCollapsed"></app-branding>
    <div>
      <img
        src="../../../../assets/images/svgs/align-justify.svg"
        class="align-middle m-2 img-sidebar"
        alt="button"
        (click)="onToggleCollapse()"
      />
    </div>
  </div>

  <mat-nav-list class="sidebar-list" id="style-1" [class.collapsed]="isCollapsed" style="overflow: auto;">
    <app-nav-item *ngFor="let item of navItems" [item]="item" [isCollapsed]="isCollapsed" [class.collapsed]="isCollapsed" style="cursor: pointer;"> </app-nav-item>
  </mat-nav-list>
</div>
<style>
  #style-1::-webkit-scrollbar {
    width: 6px;
  }
  #style-1::-webkit-scrollbar-thumb {
    background-color: #6f82c1;
  } 
</style>